import { render, staticRenderFns } from "./AppStoreBadges.vue?vue&type=template&id=70649a7f&scoped=true"
import script from "./AppStoreBadges.vue?vue&type=script&lang=js"
export * from "./AppStoreBadges.vue?vue&type=script&lang=js"
import style0 from "./AppStoreBadges.vue?vue&type=style&index=0&id=70649a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70649a7f",
  null
  
)

export default component.exports